<div class="disbursements">
  <section class="wallet" aria-labelledby="wallet-label">
    <span class="wallet-mask" aria-hidden="true"><img src="assets/icons/financials/wallet-mask.svg" alt="" /></span>
    <div class="wallet-content">
      <div class="wallet-label">
        <span id="wallet-label">Amount Held</span>
        <img src="assets/icons/financials/shield-dollar.svg" alt="" width="25" height="24" [attr.title]="amountHeldHelp" />
      </div>
      <span *ngIf="walletLoading" class="wallet-skeleton" aria-busy="true" aria-label="Loading amount held"></span>
      <strong *ngIf="!walletLoading" class="wallet-value">{{ amountHeld === null ? '—' : money(amountHeld) }}</strong>
    </div>
  </section>

  <div *ngIf="loading" class="state" aria-busy="true" aria-label="Loading payouts">
    <div class="skeleton-row" *ngFor="let _ of [1, 2, 3, 4]"></div>
  </div>

  <div *ngIf="!loading && error" class="state state--message" role="alert">
    <p>We couldn't load your payouts.</p>
    <button type="button" class="retry" (click)="load(page)">Try again</button>
  </div>

  <div *ngIf="!loading && !error && rows.length === 0" class="state state--message">
    <p>No payouts yet</p>
  </div>

  <ul *ngIf="!loading && !error && rows.length" class="payouts">
    <li *ngFor="let row of rows; trackBy: rowKey" class="payout" [class.payout--open]="isOpen(row)">
      <button type="button" class="payout-head" [attr.aria-expanded]="isOpen(row)" [attr.aria-controls]="'payout-' + row.disbursement_id" (click)="toggle(row)">
        <span class="payout-main">
          <strong class="payout-amount">{{ money(row.amount) }}</strong>
          <span *ngIf="row.reference" class="payout-ref">
            Reference
            <span class="payout-ref-value">{{ row.reference }}</span>
          </span>
        </span>
        <span class="payout-side">
          <span class="payout-date">{{ date(row) }}</span>
          <i class="bi" [ngClass]="isOpen(row) ? 'bi-chevron-down' : 'bi-chevron-right'" aria-hidden="true"></i>
        </span>
      </button>

      <div *ngIf="isOpen(row)" class="payout-body" [id]="'payout-' + row.disbursement_id">
        <p *ngIf="row.description" class="payout-description">{{ row.description }}</p>
        <p *ngIf="row.items.length" class="payout-lead">This payout includes following bookings:</p>
        <p *ngIf="!row.items.length" class="payout-lead">No bookings are listed for this payout.</p>

        <div *ngFor="let item of row.items; trackBy: itemKey" class="item">
          <h3 class="item-title">{{ item.item_label }}</h3>
          <dl class="item-details">
            <dt>Listing ID</dt>
            <dd>#{{ item.listing_id }}</dd>
            <dt>Booking ID</dt>
            <dd>#{{ item.booking_id }}</dd>
            <dt>Price</dt>
            <dd>{{ money(item.total) }}</dd>
          </dl>
          <a *ngIf="listingUrl(item) as href" class="item-link" [href]="href" target="_blank" rel="noopener">See Listing</a>
        </div>
      </div>
    </li>
  </ul>

  <nav *ngIf="!loading && !error && recordCount > 0" class="pager" aria-label="Payout pages">
    <span class="pager-count">{{ recordCount }} {{ recordCount === 1 ? 'payout' : 'payouts' }}</span>
    <button type="button" class="pager-btn" aria-label="Previous page" [disabled]="page <= 1" (click)="goTo(page - 1)">
      <img src="assets/icons/data-table/page-prev.svg" alt="" width="13" height="13" />
    </button>
    <span class="pager-page">
      Page
      <strong>{{ page }}</strong>
      of {{ pageCount }}
    </span>
    <button type="button" class="pager-btn pager-btn--next" aria-label="Next page" [disabled]="page >= pageCount" (click)="goTo(page + 1)">
      <img src="assets/icons/data-table/page-next.svg" alt="" width="13" height="13" />
    </button>
  </nav>
</div>
